export default __webpack_public_path__ + "static/DSC_0274-1f80db27d3e68bccfd1fa959c1f287bd.jpg";